'use strict';

const ProjectRoleItemViewTemplate = require('balus/ui/template/body/role-dashboard/nav/project-role-item.hbs');
const ProjectRoleListViewTemplate = require('balus/ui/template/body/role-dashboard/nav/project-role-list.hbs');
const Mn = require('backbone.marionette');

const ProjectRoleItemView = Mn.View.extend({
    tagName: 'li',
    className: function() {
        const projectRole = this.getOption('projectRole');
        if(projectRole && projectRole.id == this.model.id) {
            return 'list-item is-active';
        } else {
            return 'list-item';
        }
    },
    template: ProjectRoleItemViewTemplate,
    templateContext: function() {
        return {
            groupID: this.getOption('group').id,
            name: this.model.getName()
        }
    }
});

const ProjectRoleListView = Mn.CollectionView.extend({
    childView: ProjectRoleItemView,
    childViewContainer: '.project-role-list',
    childViewOptions: function() {
        return {
            group: this.model,
            projectRole: this.getOption('projectRole')
        }
    },
    filter: function(child) {
        return child.isSelectable();
    }
});

module.exports = Mn.View.extend({
    template: ProjectRoleListViewTemplate,
    regions: {
        projectRoleList: '.project-role-list'
    },
    ui: {
        'addProjectRoleButton': '.project-role-add-button'
    },
    events: {
        'click @ui.addProjectRoleButton': 'addProjectRole'
    },
    templateContext: function() {
        const project = this.model;
        const user = this.getOption('user');

        return {
            canAddProjectRole: project.isAdmin(user ? user.id : null),
        };
    },

    onRender: function() {
        this.showChildView('projectRoleList', new ProjectRoleListView({
            model: this.model,
            projectRole: this.getOption('projectRole'),
            collection: this.collection
        }));
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/role-dashboard/nav/project-role-list.js